import React from 'react';
const LabelsContext = React.createContext(null);

export default LabelsContext;
